/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';

// Generates a key based on the schema, params, and options
var encode;

// Check if we are client side or not
if (typeof btoa === 'undefined') {
  // If we are not base64 using ndoeJS functions
  encode = function btoa(str) {
    var buffer;
    if (str instanceof Buffer) {
      buffer = str;
    } else {
      buffer = Buffer.from(str.toString(), 'binary');
    }
    return buffer.toString('base64');
  };
} else {
  encode = btoa;
}
var getKey = (function (_ref) {
  var name = _ref.name,
    params = _ref.params,
    options = _ref.options;
  // If skip is set to true, return the skip state
  if (options && options.skip) {
    return 'skip';
  }

  /* Only generate a key based on specific parameters */
  var keyParams = _objectSpread2(_objectSpread2({
    name: name
  }, params), {}, {
    customSchema: options.customSchema,
    mock: options.mock,
    queryParams: options.queryParams,
    templateKeys: options.templateKeys,
    datahookId: options.datahookId,
    polling: options.polling
  });
  if (options.includeHeadersInKey) keyParams.headers = options.headers;
  if (options.excludePollingInKey) delete keyParams.polling;

  // generate a new key based on the params, options, and query
  return encode(encodeURIComponent(JSON.stringify(keyParams)));
});

export { getKey as default };
